import routerReducer from './router/reducer'
import {combineReducers} from 'redux'
import {persistReducer} from 'redux-persist'
import storageSession from 'redux-persist/lib/storage/session'
import {loadingBarReducer} from 'react-redux-loading-bar'
import speedBumpReducer from 'redux/speedBump/reducer'
import toastReducer from 'redux/toast/reducer'
import authReducer from 'redux/auth/reducer'
import totalsReducer from 'redux/totals/reducer'
import databasesReducer from 'redux/databases/reducer'
import jobsReducer from 'redux/jobs/reducer'
import jobRequestReducer from 'redux/jobRequests/reducer'
import diagnosticsReducer from 'redux/diagnostics/reducer'

const rootReducer = combineReducers({
  router: routerReducer,
  auth: authReducer,
  loadingBar: loadingBarReducer,
  speedBump: speedBumpReducer,
  toast: toastReducer,
  totals: totalsReducer,
  databases: databasesReducer,
  jobs: jobsReducer,
  diagnostics: diagnosticsReducer,
  jobRequests: jobRequestReducer,
})

const persistConfig = {
  key: 'root',
  storage: storageSession,
}

const persistedRootReducer = persistReducer(persistConfig, rootReducer)

export default persistedRootReducer
